import Character from "../models/character";


// Main Characters

export const Trisha: Character = {
    name: "Trisha",
    fullName: "Trisha Sanzgiri",
    ageGroup: "Early 40s",
    job: "Data Analyst",
    characteristics: [
        "Headstrong",
        "Caring",
        "Patriotic",
    ],
    synopsis: `She cares for her family but is a career focused lady at heart. She is a strong believer of justice, and is willing to go through great lengths to serve the same. Although, she does end up on the wrong side quite a few times...\n\nThe breadwinner of the family is a hardworking, stern and principled citizen who loves to take a stand for justice. She is the righteous voice for rationale most of the times, though once in a while she loses sight of what's right and what's wrong. As a result, her morale stand forces her to go overboard.\n\nShe had chosen her kids over her career for many years. But now she has stepped back into the arena, only to find herself in uncharted territory. Her Data Analysis skills may be out of date, but her common sense isn't. But is this common sense of any use when you're surrounded by people who don't have it?`,
    sketchFile: "trisha-sanzgiri.jpg",
    voiceSampleFile: "trisha-sanzgiri.m4a",
    themeColour: "#FF5E32",
    referenceCharacters: "Meera Pandit (Love Aaj Kal), Leela (Futurama), Aditi (Jaane Tu... Ya Jaane Na)",
}

export const Akshay: Character = {
    name: "Akshay",
    fullName: "Akshay Sanzgiri",
    ageGroup: "Early 40s",
    job: "Househusband",
    characteristics: [
        "Naive",
        "Impulsive",
        "Absent Minded",
    ],
    synopsis: `He might be the oldest in the family by age, but he's definitely the 'childest' at heart. A responsible but emotional fool who loves fooling around, he's also notorious for taking stereotypes too seriously...\n\nThis gullible-yet-lovable husband is the most innocent, naive yet family oriented fool who is impossible to hate. He is smart when he wants to be, but most of the time, he lets his inner child take over his personality. He is extremely curious about new concepts, often fixating on a new trend or phenomenon which backfires.\n\nDue to standards set by society, he worked in retail for a long time to feed his family, even though he would've rather spent all that time raising his kids. After he and his wife make the wise decision to swap roles, he is left dumfounded by situations which make him realise that taking care of this unconventional family is not a child's play.`,
    voiceSampleFile: "akshay-sanzgiri.m4a",
    sketchFile: "akshay-sanzgiri.jpg",
    themeColour: "darkgoldenrod",
    referenceCharacters: "Phil Dunphy (Modern Family), Michael Scott (The Office), Baburao (Hera Pheri)",
    // themeColour: "#F7EB00"
}

export const Riddhi: Character = {
    name: "Riddhi",
    fullName: "Riddhi Sanzigiri",
    ageGroup: "15 years old",
    job: "Student at SVM",
    characteristics: [
        "Extremely Intelligent",
        "Bored of life",
        "Misanthropic",
    ],
    synopsis: `She is fed-up with her family's antics. While she likes to keep her complex thoughts to herself, when required, she bluntly delivers verbal blows without sugarcoating even a word. She might know something that others don't...\n\nHer personality summarizes what happens when someone learns a lot about humans — they give up on humanity. She is so intelligent that she has realised: there is no hope left. For school, for love, for live — there is no hope left.\n\nAs a result of intense knowledge, she has a reserved nature which is often perceived as rude and arrogant. Although from her perspective, she would rather not waste energy on a conversation that will not bear fruit. She frequently tops her class in academics, but other talents are often blocked by her unwillingness to pursue any passion, because "सब को तो मरना ही है।" (transl. "We're all gonna die, anyway.").`,
    voiceSampleFile: "riddhi-sanzgiri.m4a",
    sketchFile: "riddhi-sanzgiri.jpg",
    themeColour: "black",
    referenceCharacters: "Squidward (SpongeBob SquarePants), Eeyore (Winnie The Pooh), Rocket Raccoon (Guardians of the Galaxy)"

}

export const Parth: Character = {
    name: "Parth",
    fullName: "Parth Sanzgiri",
    ageGroup: "11 years old",
    job: "ITUS– sorry, Student at SVM",
    characteristics: [
        "Street Smart",
        "Mischieveous",
        "Astute"
    ],
    synopsis: `He is an outgoing troublemaker for the world but a shy and innocent kid for his mimi. After all, his pranks are for fun, not for creating a ruckus; at least that's what he thinks...\n\nBe careful when you deal with him - he might look like a harmless kid, but he'll sell you to yourself before you know it. He'll regularly go on extremely dangerous adventures without adult supervision and escape without a scratch. Often dealing with a wide range of personalities - ranging from a Mad Scientist to a Gangster - his street-smartness is unparalleled. This dual life of his is not something which his parents are aware of.\n\nHe has only one motive in life - have fun. He barely manages to pass his exams, but he'll be the highest scorer in a cricket match. Maybe he can't name all the Indian states, but he can name every Indian movie released this year — with its cast and crew.`,
    voiceSampleFile: "parth-sanzgiri.m4a",
    sketchFile: "parth-sanzgiri.jpg",
    themeColour: "#2A61FA",
    referenceCharacters: "Simmba (Simmba), Bart Simpson (The Simpsons), Tappu (Taarak Mehta Ka Ooltah Chashmah)"
}


// Recurring Characters

// Shetty Family

export const Manjula: Character = {
    name: "Manjula",
    fullName: "Manjula Shetty",
    ageGroup: "Late 30s",
    job: "Housewife",
    characteristics: [
        "Gossip monger"
    ],
    synopsis: "Satish's caring mother also happens to be the source of all the gossip in the society. She keeps an eye (or maybe ear) on everything happening in her housing society.",
    voiceSampleFile: "manjula-shetty.m4a",
}

export const Appu: Character = {
    name: "Appu",
    fullName: "Apurva Shetty",
    ageGroup: "Late 30s",
    job: "Owner of a Grocery Store",
    characteristics: [
        "Money minded"
    ],
    synopsis: "Started from nowhere with nothing, and today, he owns and runs the popular Shetty Grocery Store. Wait, I meant Shetty Supermarket, or at least he'll make me say that; although everyone knows it's just a Grocery Store. But he claims it's a Supermarket.",
    sketchFile: "appu-shetty.jpg",
    voiceSampleFile: "appu-shetty.m4a"
}

export const Satish: Character = {
    name: "Satish",
    fullName: "Satish Shetty",
    ageGroup: "11 years old",
    job: "Student at SVM",
    characteristics: [
        "Sick/unwell", "Imaginative"
    ],
    synopsis: "Parth's best friend is always ill - maybe cold, maybe flu, or maybe some disease that hasn't been discovered yet. His life often revolves around popping pills and supporting Parth through thick and thin.\n\nHe has the biggest imagination of all, which sadly goes unappreciated by Parth.",
    sketchFile: "satish-shetty.jpg",
    voiceSampleFile: "satish-shetty.m4a"
}

export const MAD: Character = {
    name: "MAD",
    fullName: "Murugannukrishna Anananthaswamy Daithyakulantaka",
    ageGroup: "Early 30s",
    job: "Scienti- umm, I mean, labourer",
    characteristics: [
        "Intelligent", "Zero Street-Smarts",
    ],
    synopsis: "Don't let his simple appearance and clothing fool you! He's convinced his neighbours that he's a good-for-nothing nobody, but he's actually a mad scientist in disguise. He has no friends, but he also doesn't have time for any; he's too busy inventing and tinkering.\n\nWhat could be his next invention? Maybe it's a luck booster chip. Maybe it's a memory retention pill. Maybe it's a Time Machine. Who knows? He has a lot going on in his simple-looking flat.",
    sketchFile: "mad-scientist.jpg",
    voiceSampleFile: "mad-scientist.m4a",
}

export const Bhaskar: Character = {
    name: "Bhaskar",
    fullName: "Bhaskar Tripathi",
    ageGroup: "Early 60s",
    job: "Secretary of the society",
    characteristics: [
        "Pedantic", "Extremely annoying", "Lonely"
    ],
    synopsis: "This nosey, irritating, grumpy chairman of the society's committee is constantly poking his nose at everything happening in the society. He frequently nags residents and even the watchmen. His constant opposition of 'fun' often puts him at loggerheads with Parth and his friends.\n\nHaving no family of his own, he is always trying to boss around others. And he wonders why nobody wants to befriend him...",
    sketchFile: "bhaskar-tripathi.jpg",
    voiceSampleFile: "bhaskar-tripathi.m4a",
}

export const Annie: Character = {
    name: "Annie",
    fullName: "Annie D'cunha",
    ageGroup: "Early 30s",
    job: "Housewife",
    characteristics: [
        "Clumsy", "Welcoming"
    ],
    synopsis: "An animal lover who adopts any helpless pet she sees. It sounds nice until you hear about her clumsiness, which even the pets don't like. The total count of pets is on debate - last Manjula heard, it was eleven, and that included a python.",
    sketchFile: "annie-dcunha.jpg",
}

export const Kevin: Character = {
    name: "Kevin",
    fullName: "Kevin D'cunha",
    ageGroup: "Mid 30s",
    job: "Unknown",
    characteristics: [
        "Extremely Buff"
    ],
    synopsis: "Annie's husband is extremely tall, extremely buff, extremely secretive. Nobody knows what he does for a living, but given his physique, nobody dares to ask. Also, nobody has ever heard him speak.",
    sketchFile: "kevin-dcunha.jpg"
}

// Recurring Characters

export const ChhotaBhai: Character = {
    name: "Chhota Bhai",
    fullName: "Unknown",
    ageGroup: "Early 30s",
    job: "Evading the police",
    characteristics: [
        "Empathetic", "Kind at heart"
    ],
    synopsis: "A wannabe gunda, his plans of gunda-raj often fail because his heart is too sweet (unlike his voice). He admires Bada Bhai but his kind nature holds him back. He's always on the run from the police.",
    sketchFile: "chhota-bhai.jpg",
    voiceSampleFile: "chhota-bhai.m4a",
    themeColour: "#a05c4e"
}

export const Gilli: Character = {
    name: "Gilli",
    fullName: "Unknown",
    ageGroup: "Late 20s",
    job: "Helping Chhota Bhai",
    characteristics: [
        "Characterless", "Not very smart"
    ],
    synopsis: "Chhota Bhai's sidekick doesn't do much other than help him and follow orders. But he's willing to do anything - even stay on the run with him.",
    voiceSampleFile: "gilli-bhai.m4a",
    sketchFile: "gilli-bhai.jpg",
}

export const BadaBhai: Character = {
    name: "Bada Bhai",
    fullName: "Bada Bhai",
    ageGroup: "Early 50s",
    job: "Founder and CEO of Bada Bhai Industries",
    characteristics: [
        "Cunning", "Greedy"
    ],
    synopsis: "A businessman for the world but a gangster for the underworld, he is feared by one and all. His diction and vocabulary may seem educated, but his mind is clearly not. The police have no evidence against him.\n\nMaybe the rumours of him being an alien are true...",
    voiceSampleFile: "bada-bhai.m4a",
    sketchFile: "bada-bhai.jpg",
}

export const InspectorRathore: Character = {
    name: "Inspector Rathore",
    fullName: "Chintu Rathore",
    ageGroup: "Mid 30s",
    job: "Police Inspector",
    characteristics: [
        "Unlucky", "Kind"
    ],
    synopsis: "He's smart and solves the case, but his plan to arrest is always foiled due to a series of coincidences and misfortunes, usually unknowingly caused by the Sanzgiri family. He hasn't made a single arrest yet.",
    voiceSampleFile: "inspector-rathore.m4a"
}

export const DrDoctor: Character = {
    name: "Dr. Doctor",
    fullName: "Dr. Norul Taronish Doctor",
    ageGroup: "Mid 40s",
    job: "Physician",
    characteristics: [
        "Calm and Relaxed", "Airheaded"
    ],
    synopsis: "An incompetent doctor who, however catastrophic the emergency is, will remain patient even if the patient becomes impatient. Maybe his degree *is* forged...",
    voiceSampleFile: "dr-doctor.m4a",
    sketchFile: "dr-doctor.jpg",
}

export const VinodHasmukhani: Character = {
    name: "Vinod Hasmukhani",
    fullName: "Vinod Hasmukhani",
    ageGroup: "Late 40s",
    job: "News Anchor at Jhatpat News",
    characteristics: [
        "Joyless", "Serious"
    ],
    synopsis: "A journalist who, unlike his name, has never smiled in his life. He is the star news anchor for Jhatpat News.",
    voiceSampleFile: "vinod-hasmukhani.m4a",
    sketchFile: "vinod-hasmukhani.jpg",
}

export const MainCharacterList: Character[] = [
    Akshay,
    Trisha,
    Riddhi,
    Parth,
];

export const NeighbourCharacterList: Character[] = [
    Appu,
    Manjula,
    Satish,
    Bhaskar,
    MAD,
    Annie,
    Kevin
]

export const RecurringCharacterList: Character[] = [
    ChhotaBhai,
    Gilli,
    BadaBhai,
    InspectorRathore,
    VinodHasmukhani,
    DrDoctor,
]
